/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventChatMemberAddedContentDto { 
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * название чата, в котором событие
     */
    chatName: string;
    /**
     * id добавленного пользователя в чат
     */
    userId: string;
    /**
     * Имя добавленного пользователя
     */
    userName: string;
    /**
     * Признак наличия у пользователя аватарки
     */
    isAvatarExists: boolean;
}

